import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, NavX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { VStack, XText } from "IZOX/_X";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

/**
 * @augments {Component<Props, State>}
 */
class PLogout extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      setTimeout(() => {
        this._Redirect();
      }, 2000);
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PLogout.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _Redirect = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Home");
  }

  render(){
    return (
      <VStack flexGrow={1} bgColor={ColorX.CSS("Grass")} fullWidth fullHeight>
        <VStack fullHeight VAlign="-" spacing={24}>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} textAlign="|">
            {LocaleX.Parse({
              EN: "You have successfully logged out",
              TC: "你已經登出"
            })}
          </XText>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")} textAlign="|">
            {LocaleX.Parse({
              EN: "Thank you for using our company's services",
              TC: "多謝閣下使用本公司服務"
            })}
          </XText>
        </VStack>
      </VStack>
    );
  }

}

export default withRouter(observer(PLogout));
